class HandleBlockAgendaTabs{
	constructor(){
		window.addEventListener('click', this.handleClick.bind(this), false);
	}

	handleClick(e){
		let target = e.target.closest('.atonal-agenda__tabbar button');
		if( !target ) return;
		let id = target.getAttribute('aria-controls');
		let tabs = target.closest('.atonal-agenda').querySelectorAll('.atonal-agenda__tab');
		let buttons = target.closest('.atonal-agenda__tabbar').querySelectorAll('button');
		tabs && tabs.forEach( el => el.setAttribute('aria-hidden', el.getAttribute('id') === id ? 'false' : 'true') );
		buttons && buttons.forEach( bt => { bt.setAttribute('aria-expanded', bt !== target ? 'false' : 'true') } );
	}
}

new HandleBlockAgendaTabs();
